"use strict";

import React, {Component} from 'react';
import PropTypes from "prop-types";

class Section extends Component {

    static propTypes = {
        className: PropTypes.string,
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { className } = this.props;

        return (
            <section className={ className }>
                {this.props.children}
            </section>
        )
    }
}

export default Section;